import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenuTriangle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 6,
	height: 4,
	viewBox: "0 0 6 4",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#CAD5E3",
		fillRule: "evenodd",
		d: "m3 4 3-4H0z"
	})
});
export default SvgMenuTriangle;
